import React from 'react';
import { FaDog } from 'react-icons/fa';

/**
 * SideDogIcon — bewusst GEFÜLLTE Seitenansicht eines Hundes.
 *
 * Verwendet dasselbe Icon wie die Statistik-Karten auf der Seite
 * `/dog-management-beta` (Font Awesome `FaDog` via react-icons), damit die
 * Hunde-Darstellung projektweit konsistent ist.
 *
 * Fachliche Ausnahme laut Issue #9: Wo fachlich „Hund" gemeint ist, wird
 * ausschließlich dieses Icon verwendet – niemals HeartIcon, PawIcon oder
 * wechselnde Symbole. Die gefüllte Darstellung ist absichtlich gewählt,
 * weil der Hund dadurch schneller erkennbar ist.
 *
 * Größen-, Abstands- und Farbregeln gelten wie für Heroicons (className).
 */
const SideDogIcon: React.FC<{ className?: string }> = ({ className }) => {
  const IconComponent = FaDog as React.ComponentType<{
    className?: string;
    'aria-hidden'?: boolean | 'true' | 'false';
    focusable?: string;
  }>;
  return (
    <IconComponent className={className} aria-hidden="true" focusable="false" />
  );
};

export default SideDogIcon;
